import {
    CORE_LOAD_ALL_BUILDINGS_REQUEST,
    CORE_LOAD_ALL_BUILDINGS_SUCCESS,

    CORE_LOAD_BUILDING_REQUEST,
    CORE_LOAD_BUILDING_SUCCESS,

    CORE_FILTER_BUILDING_REQUEST,
    CORE_FILTER_BUILDING_SUCCESS,


} from '../../types'


const initialState = []
export default {
    buildings: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_BUILDINGS_REQUEST:
            case CORE_FILTER_BUILDING_REQUEST:
                return initialState

            case CORE_LOAD_ALL_BUILDINGS_SUCCESS:
            case CORE_FILTER_BUILDING_SUCCESS:
                if (action.payload[0]) {
                    let payload = action.payload
                    let buildings = []
                    payload.forEach(data => {
                        buildings.push({
                            _id: data._id,
                            name: data.name,
                        })
                    })
                    return buildings
                }
                return action.payload
            default:
                return state
        }
    },
    building: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_BUILDING_REQUEST:
                return initialState
            
            case CORE_LOAD_BUILDING_SUCCESS:
                return action.payload
            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/features/buildings/reducer.js